import React from 'react'
import { getPlayerRoles } from '../../../../lib/utils/common'

const Team = ({
  details = {}
}) => {

  let players = details.players || []
  let playerNames = ''
  players.map((p, i) => {
    let playerRole = getPlayerRoles(p.name, p.roles, i==players.length-1 ?  '' : ', ') || {}
    let s = playerRole.__html || ''
    playerNames += s
  })

  let teamMarkup = { __html : `${playerNames}` }

  return (
    <div className="cricinfo__content__item">
      <h2 className="cricinfo__sub-title">{details.name} Team</h2>
      <div className="cricinfo__content__detail" dangerouslySetInnerHTML={teamMarkup}></div>
    </div>
  )
}

export default Team



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/lite/Team.jsx